import React, {useState, useEffect} from 'react';
import { useForm, Controller} from 'react-hook-form';
import Select from "react-select";
import { NumericFormat } from 'react-number-format';
import schedulePayService from '../../services/SchedulePayService';

const  statusType = [
    { label: 'In Attesa', value: 'In Attesa' },
    { label: 'Pagato', value: 'Pagato' },
    { label: 'Insoluto', value: 'Insoluto' },
    { label: 'Parziale', value: 'Parziale' }
];

export default function LayerEdit({show,onClose,onFetchPay,schedulePay}) {
    const { register, control, handleSubmit, reset, watch, getValues, setValue,setError,clearErrors,formState: { errors } } = useForm({});
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [resultsCat, setResultsCat] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isPartial, setIsPartial] = useState(false);

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
    };

    const handleActionPay= async (data) => {
        if (!generateAmount()) return;

        const statusFormat = data.status
            ? data.status.value
            : data.status;
        const parAmountFormat = data.partialAmount && String(data.partialAmount).includes(',')
          ? data.partialAmount.replace(/\./g, '').replace(/,/g, '.').replace(/[^\d.-]/g, '')
          : data.partialAmount;
        const payload = {
            ...data,
            partialAmount: Number(parAmountFormat),
            status:statusFormat
        };

       schedulePayService.update(payload,reset)
            .then((res) => {
                setMessage("Pagamento aggiornato con successo!");
                setErrorMsg("");
                onFetchPay();
            }).catch((error) => {
                console.error("Error update pay: ", error);
                setMessage("");
                setErrorMsg("Errore aggiornamento pagamento. Riprova.");
            }
        );
    }

    useEffect(() => {
        const statusValue = statusType.find(s => s.value === schedulePay.status);
        if (statusValue.value === "Parziale") {setIsPartial(true);}
        reset({
            ...schedulePay,
            status: statusValue
        });
    }, [schedulePay, reset]);

    const checkStatus= () => {
        const statusValue = getValues("status");
        setIsPartial(false);
        if(statusValue.value === "Pagato" && getValues("mode") === "Bonifico") {
            setValue('datePay', new Date().toISOString().split('T')[0]);
        } else if (statusValue.value === "Pagato") {
            setValue('datePay', getValues("dueDate"));
        } else if (statusValue.value === "Parziale") {
            setIsPartial(true);
            setValue('datePay', new Date().toISOString().split('T')[0]);
        } else setValue('datePay', null);
    }
    const generateAmount= () => {
        const statusValue = getValues("status");
        const parAmountValue = getValues("partialAmount");
        const amountValue = getValues("amount");
        const parAmountFormat = parAmountValue && String(parAmountValue).includes(',')
          ? Number(parAmountValue.replace(/\./g, '').replace(/,/g, '.').replace(/[^\d.-]/g, ''))
          : Number(parAmountValue);
        if (parAmountFormat >= amountValue) {
            setError(`partialAmount`, {
                type: 'manual',
                message: 'L\'importo parziale deve essere minore dell\'importo del pagamento',
            });
            return false;
        }
        if (statusValue.value === "Parziale" && parAmountFormat === 0) {
            setError(`partialAmount`, {
                type: 'manual',
                message: 'Per lo stato parziale il campo è richiesto',
            });
            return false;
        }
        clearErrors();
        const value = amountValue - parAmountFormat;
        setValue('remainingPay', value);
        return true;
    }
    useEffect(() => {
        const subscription = watch((value, { name }) => {
            switch (name) {
                case 'status':
                    checkStatus();
                    break;
                case 'partialAmount':
                    generateAmount();
                    break;
                default: break;
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

  	return (
  	    <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Modifica pagamento del contratto {schedulePay ? schedulePay.numberContract.toString().padStart(3, "0") : ""}</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionPay)}>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Numero Fattura</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.name ? "is-invalid" : ""}`}>
                                    <i className="bx bx-barcode" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="invoice"
                                    rules={{ maxLength: {value: 100,message: 'Massimo 100 caratteri' }}}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className={`form-control ${errors.invoice ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.invoice && <div className="invalid-input">{errors.invoice.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Data Fattura</label>
                            <input className={`form-control ${errors.invoice_date ? "is-invalid" : ""}`}
                                type="date"
                                placeholder={`${errors.invoiceDate ? errors.invoiceDate.message : ""}`}
                                {...register("invoiceDate")}
                             />
                            {errors.invoiceDate && <div className="invalid-input">{errors.invoiceDate.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 mb-6">
                            <label className="form-label">Iva</label>
                            <select className={`form-select ${errors.iva ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="Seleziona uno stato"
                                {...register('iva', { required: 'Richiesto' })}
                            >
                                <option value="true">Si</option>
                                <option value="false">No</option>
                            </select>
                            {errors.iva && <div className="invalid-input">{errors.iva.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Esito</label>
                                <Controller
                                name="status"
                                control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            placeholder="Seleziona"
                                            classNamePrefix='filter'
                                            options={statusType}
                                        />
                                    )}
                                />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Data Pagamento</label>
                            <input className={`form-control ${errors.datePay ? "is-invalid" : ""}`}
                                type="date"
                                placeholder={`${errors.datePay ? errors.datePay.message : ""}`}
                                {...register("datePay")}
                             />
                            {errors.datePay && <div className="invalid-input">{errors.datePay.message}</div>}
                        </div>
                    </div>
                    {isPartial
                    && (
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Importo Parziale*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.partialAmount ? "is-invalid" : ""}`}>
                                    <i className="bx bx-euro" ></i>
                                </span>
                                <Controller
                                    name="partialAmount"
                                    control={control}
                                    render={({ field }) => (
                                        <NumericFormat
                                            {...field}
                                            className={`form-control ${errors.partialAmount ? "is-invalid" : ""}`}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            allowNegative={false}
                                        />
                                    )}
                                />
                            </div>
                            {errors.partialAmount && <div className="invalid-input">{errors.partialAmount.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Pagamento Residuo</label>
                            <Controller
                                name="remainingPay"
                                control={control}
                                render={({ field }) => (
                                    <NumericFormat
                                        {...field}
                                        className={`form-control ${errors.remainingPay ? "is-invalid" : ""}`}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        decimalScale={2}
                                        prefix={'€ '}
                                        fixedDecimalScale={true}
                                        allowNegative={false}
                                        disabled
                                    />
                                )}
                            />
                            {errors.remainingPay && <div className="invalid-input">{errors.remainingPay.message}</div>}
                        </div>
                    </div>
                    )}
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Note</label>
                            <Controller
                                control={control}
                                name="note"
                                rules={{
                                    maxLength: {
                                        value: 512,
                                        message: 'Massimo 512 caratteri'
                                    }
                                }}
                                render={({ field }) => (
                                    <textarea
                                        {...field}
                                        placeholder="Aggiungi una nota..."
                                        className={`form-control ${errors.note ? "is-invalid" : ""}`}
                                        rows="4"
                                    />
                                )}
                            />
                            {errors.note && <div className="invalid-input">{errors.note.message}</div>}
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary me-3">Invia</button>
                </form>
            </div>
  	    </div>
	);
}